module.exports = __webpack_public_path__ + "img/dreams.jpg";